// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as SecondaryExitIcon$LiteracyplanetTupperware from "../v2/SecondaryExitIcon.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";
import * as K2ExerciseInSeriesContainer$LiteracyplanetTupperware from "../v2/K2ExerciseInSeriesContainer.res.mjs";

function PilotfulLayoutContainer$ExitButton(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onExit = match.onExit;
  return React.createElement("button", {
              className: "cursor-pointer flex h-full select-none justify-self-end items-center justify-center gap-2",
              onClick: (function (param) {
                  Curry._1(onExit, undefined);
                })
            }, React.createElement("div", undefined, "Exit"), React.createElement(SecondaryExitIcon$LiteracyplanetTupperware.make, {
                  className: "h-[60%] fill-black"
                }));
}

var ExitButton = {
  make: PilotfulLayoutContainer$ExitButton
};

function PilotfulLayoutContainer(props) {
  V2ExerciseContext$LiteracyplanetTupperware.use();
  return React.createElement(React.Fragment, {}, React.createElement("link", {
                  href: "https://use.typekit.net/hzt6ypm.css",
                  rel: "stylesheet"
                }), React.createElement(K2ExerciseInSeriesContainer$LiteracyplanetTupperware.make, {
                  questionCount: props.questionCount,
                  children: React.createElement("div", {
                        className: "h-screen"
                      }, React.createElement("div", {
                            className: "h-[3vw]"
                          }, React.createElement(PilotfulLayoutContainer$ExitButton, {})), props.children)
                }));
}

var make = PilotfulLayoutContainer;

var $$default = PilotfulLayoutContainer;

export {
  ExitButton ,
  make ,
  $$default as default,
}
/* react Not a pure module */
